import { createApiClient } from '@wix/premium-fed-sdk/@apis-infra-react';
import { StudioSiteQueriesConfig } from './studio-site.queries';
export const StudioSiteApiClient = createApiClient(StudioSiteQueriesConfig);
//# sourceMappingURL=studio-site.api-client.js.map